/**
 * Entity Actions - Central Export
 * Re-exports all entity-specific action definitions
 * Provides convenient access to actions for each entity
 */

export { contactDetailActions } from "@/features/contacts/actions/contact-actions";
export { ticketDetailActions } from "@/features/tickets/actions/ticket-actions";
export { taskDetailActions } from "@/features/tasks/actions/task-actions";
export { companyDetailActions } from "@/features/companies/actions/company-actions";
export { dealDetailActions } from "@/features/deals/actions/deal-actions";
export { timeEntryDetailActions } from "@/features/time-entries/actions/time-entry-actions";
export { contractDetailActions } from "@/features/contracts/actions/contract-actions";
export { socialMediaPostDetailActions } from "@/features/social-media-posts/actions/social-media-post-actions";
export { userDetailActions } from "./user-actions";
